import React from "react";
import { Link } from "react-router-dom";
import AgendaData27 from "../data/AgendaData27";

const SessionListItems = ({ items }) => {
  return (
    <ul className="expert-list">
      {items.map((item, index) => (
        <li key={index}>
          <h2>{item}</h2>
        </li>
      ))}
    </ul>
  );
};

const SessionListContainer = ({ CertifiedLearning }) => {
  const midIndex = Math.ceil(CertifiedLearning.length / 2); // add/subtract 1 to adjust columns
  const firstHalf = CertifiedLearning.slice(0, midIndex);
  const secondHalf = CertifiedLearning.slice(midIndex);

  return (
    <section className="bg-purple bg-rounded-bottom">
      <div className="container my-5">
        <div className="row text-center pb-5">
          <div className="col">
            <h1 className="color-white">Certified learning</h1>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 mb-4">
            <SessionListItems items={firstHalf} />
            <SessionListItems items={secondHalf} />
          </div>

          <div className="row">
            <div className="col text-center">
              <Link to="/agenda" className="btn-white-o">
                View full Agenda <i className="fa fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default function SessionListImporter() {
  const excludedTitles = [
    "Breakfast",
    "Lunch (Workshop Participants Only)",
    "FinComp Registration",
    "TBA",
    "Morning Break",
    "Afternoon Break",
    "HR Roundtables",
    "Breakfast & Registration",
    "Lunch",
    "Networking Mixer",
    "Networking Event",
    "Closing Remarks",
  ];

  // const additionalTitles = ["More to come!"];
  const additionalTitles = [];

  const eventTitles = AgendaData27.flatMap((day) =>
    day.events.flatMap((event) => {
      const titles = [];

      // Add event title if it exists and is not excluded
      if (event.title && !excludedTitles.includes(event.title)) {
        titles.push(event.title);
      }

      // Add session titles if present and not excluded
      if (Array.isArray(event.sessions)) {
        event.sessions.forEach((session) => {
          if (session.title && !excludedTitles.includes(session.title)) {
            titles.push(session.title);
          }
        });
      }

      return titles;
    }),
  );

  const combinedTitles = [...new Set([...eventTitles, ...additionalTitles])];

  return <SessionListContainer CertifiedLearning={combinedTitles} />;
}
